import { TopToolbar, useRecordContext } from "react-admin";
import CateogryDeleteButton from "./CateogryDeleteButton";

const CategoryEditActions = () => {
  const record = useRecordContext();

  return (
    <TopToolbar>
      {record && record.isAdminCreated ? <CateogryDeleteButton /> : null}
    </TopToolbar>
  );
};

export default CategoryEditActions;
